module.exports = __webpack_public_path__ + "static/media/passport template.99607a58.png";